import FloatingDropdownSelect from "@/components/ui/input/FloatingDropdownSelect";
import { Select } from "@/components/ui/input";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import clsx from "clsx";
import React, { useCallback, useMemo } from "react";

function FerryVehicleSelect({
  tempValues,
  setTempValues,
  ferryVehicles,
  defaultVehicleType,
}) {
  const t = useTranslationDetector();

  const isWithVehicle = !!tempValues?.isWithVehicle;
  const vehicleType = tempValues?.vehicleType || "";
  const options = useMemo(() => {
    return ferryVehicles.map((vehicle) => ({
      value: vehicle.Id,
      label: vehicle.Name,
      slug: vehicle.Slug,
    }));
  }, [ferryVehicles]);

  const handleTabClick = useCallback(
    (bool) => {
      setTempValues((prev) => ({ ...prev, isWithVehicle: bool }));
    },
    [setTempValues],
  );

  const handleSelectVehicleType = useCallback(
    (e) => {
      const value = e.target.value;
      const found = options.find((o) => o.value === value);
      const next = found ? { value: found.value, label: found.label } : null;
      setTempValues((prev) => ({ ...prev, vehicleType: next }));
    },
    [options, setTempValues],
  );

  const handleFloatingDropdownChange = useCallback(
    (option) => {
      setTempValues((prev) => ({ ...prev, vehicleType: option || null }));
    },
    [setTempValues],
  );

  return (
    <div className="p-4">
      <div className="relative flex gap-4 md:inline-flex md:w-auto md:justify-start">

        {/* Without Vehicle */}
        <button
          className="relative inline-flex cursor-pointer items-center justify-start gap-2 rounded-md py-2 text-left transition-all duration-200 ease-in-out"
          onClick={() => handleTabClick(false)}
        >
          <span
            className={clsx(
              "relative h-6 w-6 rounded-full border transition-all duration-200 ease-in-out",
              !isWithVehicle
                ? "bg-primary border-primary"
                : "border-primary-weak bg-white",
            )}
          >
            <span
              className={clsx(
                "absolute top-1/2 left-1/2 h-0 w-0 origin-center -translate-x-1/2 -translate-y-1/2 rounded-full bg-white transition-all duration-200 ease-in-out",
                !isWithVehicle && "h-2 w-2",
              )}
            />
          </span>
          <span className={clsx("text-sm", !isWithVehicle && "text-foreground")}>
            {t("ferry.withoutVehicle")}
          </span>
        </button>

        {/* With Vehicle */}
        <button
          className="relative inline-flex cursor-pointer items-center justify-start gap-2 rounded-md py-2 text-left transition-all duration-200 ease-in-out"
          onClick={() => handleTabClick(true)}
        >
          <span
            className={clsx(
              "relative h-6 w-6 rounded-full border transition-all duration-200 ease-in-out",
              isWithVehicle
                ? "bg-primary border-primary"
                : "border-primary-weak bg-white",
            )}
          >
            <span
              className={clsx(
                "absolute top-1/2 left-1/2 h-0 w-0 origin-center -translate-x-1/2 -translate-y-1/2 rounded-full bg-white transition-all duration-200 ease-in-out",
                isWithVehicle && "h-2 w-2",
              )}
            />
          </span>
          <span className={clsx("text-sm", isWithVehicle && "text-foreground")}>
            {t("ferry.withVehicle")}
          </span>
        </button>
      </div>
      {isWithVehicle && (
        <FloatingDropdownSelect
          id="vehicleTypeFloating"
          label={t("ferry.vehicleSelectLabel")}
          options={options}
          placeholder={t("ferry.vehicleSelectPlaceholder")}
          value={vehicleType?.value || defaultVehicleType?.value || ""}
          onChange={(e) => {
            if (e?.target) {
              handleSelectVehicleType(e);
            } else {
              handleFloatingDropdownChange(e);
            }
          }}
          returnOption
          className="mt-5 flex-1"
        />
      )}
    </div>
  );
}

export default FerryVehicleSelect;
